/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitPrivacyCookieCompliance
 */
export interface MonitPrivacyCookieCompliance {
    /**
     * 
     * @type {string}
     * @memberof MonitPrivacyCookieCompliance
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPrivacyCookieCompliance
     */
    tier: string;
}

/**
 * Check if a given object implements the MonitPrivacyCookieCompliance interface.
 */
export function instanceOfMonitPrivacyCookieCompliance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "provider" in value;
    isInstance = isInstance && "tier" in value;

    return isInstance;
}

export function MonitPrivacyCookieComplianceFromJSON(json: any): MonitPrivacyCookieCompliance {
    return MonitPrivacyCookieComplianceFromJSONTyped(json, false);
}

export function MonitPrivacyCookieComplianceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPrivacyCookieCompliance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider': json['provider'],
        'tier': json['tier'],
    };
}

export function MonitPrivacyCookieComplianceToJSON(value?: MonitPrivacyCookieCompliance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider': value.provider,
        'tier': value.tier,
    };
}

